module.exports = __webpack_public_path__ + "img/normal.7c99f30b.jpg";